<template>
<div id="join">
    <Nav type="transparent" />
    <span class="pageTitle">加盟会员</span>
    <div class="pContent">
        <div class="building">
            建设中，敬请期待～
        </div>
    </div>
</div>
</template>

<script>
import Nav from '@/components/Nav.vue'
export default {
    name: 'Join',
    data (){
        return {

        }
    },
    components: {
        Nav,
    },
    computed: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>
    #join {
        padding: 350px 0 40px;
        background: url(../assets/pJoin-banner.jpg) top/auto 350px no-repeat;
    }
    .pContent {
        margin: 0 auto;
        width: 90%;
        max-width: 1200px;
    }
    .building {
        height: 400px;
        font-size: 40px;
        line-height: 400px;
        text-align: center;
    }
    .mob {
        #join {
            padding: 350px 32px 140px;
            background: url(../assets/join-banner.jpg) top/100% no-repeat;
        }
        .building {
            height: 800px;
            line-height: 800px;
        }
    }
</style>
